export const CHAINS = Object.freeze({
  ETHEREUM: 'ethereum',
  BITCOIN: 'bitcoin',
});

export const CHAIN_LABELS = Object.freeze({
  [CHAINS.ETHEREUM]: 'Ethereum',
  [CHAINS.BITCOIN]: 'Bitcoin',
});

// ETH: 0x followed by 40 hex chars (42 total)
const ETH_REGEX = /^0x[a-fA-F0-9]{40}$/;
// BTC: extended public key (xpub/ypub/zpub), base58, ~111 chars
const BTC_REGEX = /^(xpub|ypub|zpub)[1-9A-HJ-NP-Za-km-z]{100,120}$/;

export const VALUE_PLACEHOLDERS = Object.freeze({
  [CHAINS.ETHEREUM]: '0xd8dA6BF26964aF9D7eEd9e03E53415D37aA96045',
  [CHAINS.BITCOIN]: 'zpub… (extended public key)',
});

// Returns an error message string, or null if the value is valid for the chain.
export const validateAddressValue = (chain, value) => {
  const trimmed = (value || '').trim();
  if (!trimmed) return 'Value is required';

  if (chain === CHAINS.ETHEREUM) {
    return ETH_REGEX.test(trimmed)
      ? null
      : 'Invalid Ethereum address (expected 0x + 40 hex characters)';
  }

  if (chain === CHAINS.BITCOIN) {
    return BTC_REGEX.test(trimmed)
      ? null
      : 'Invalid Bitcoin address (expected an xpub/ypub/zpub extended public key)';
  }

  return 'Unknown chain';
};
